import { FC } from 'react';

import type {
  CollapsePanelProps,
  CollapseProps as DefaultCollapseProps,
} from 'antd/es/collapse';

import { UpArrowIcon, DownArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import { StyledCollapse } from './CollapseStyle';

export type CollapseProps = DefaultCollapseProps & {
  panelProps: CollapsePanelProps;
};

const Collapse: FC<CollapseProps> = ({
  panelProps,
  children,
  className,
  expandIcon = ({ isActive }) => (
    <CustomIcon
      fontSize={16}
      paletteColor='primaryBrand'
      icon={isActive ? UpArrowIcon : DownArrowIcon}
    />
  ),
  ...otherCollapseProps
}) => {
  return (
    <StyledCollapse
      expandIconPosition='right'
      className={className}
      expandIcon={expandIcon}
      {...otherCollapseProps}
    >
      <StyledCollapse.Panel
        {...panelProps}
        showArrow={
          panelProps?.showArrow === undefined ? true : panelProps?.showArrow
        }
      >
        {children}
      </StyledCollapse.Panel>
    </StyledCollapse>
  );
};

export default Collapse;
